import { Cookie, CupSoda, CakeSlice, Gem, Palette, Sprout, Sandwich, PenLine } from "lucide-react";

export const PRODUCTS = [
  { id: "cookies", icon: Cookie, color: "bg-amber-300", es: "Galletas", en: "Cookies" },
  { id: "lemonade", icon: CupSoda, color: "bg-yellow-300", es: "Limonada", en: "Lemonade" },
  { id: "cupcakes", icon: CakeSlice, color: "bg-pink-300", es: "Postres y cupcakes", en: "Cupcakes & desserts" },
  { id: "snacks", icon: Sandwich, color: "bg-orange-300", es: "Comida y snacks", en: "Food & snacks" },
  { id: "bracelets", icon: Gem, color: "bg-violet-300", es: "Pulseras", en: "Bracelets" },
  { id: "art", icon: Palette, color: "bg-sky-300", es: "Dibujos y stickers", en: "Drawings & stickers" },
  { id: "plants", icon: Sprout, color: "bg-lime-300", es: "Plantitas", en: "Little plants" },
  { id: "other", icon: PenLine, color: "bg-white", es: "Otra idea", en: "Other idea" },
];

export const BIZ_TEXT = {
  es: {
    title: "Taller de negocios de Lumi",
    step1: "1. ¿Qué te gustaría aprender a vender?",
    otherPh: "Escribe tu idea (ej: slime, galletas de perro...)",
    step2: "2. Súper poder: ¡ponle nombre a tu negocio!",
    power: "Usar mi súper poder",
    thinking: "Lumi está pensando...",
    again: "Otros nombres",
    pick: "Elegir este",
    saved: "¡Guardado en Mis negocios!",
    tip: "Consejo de Lumi",
    mine: "Mis negocios",
    signIn: "Entra para usar el súper poder de Lumi",
    error: "Lumi no pudo pensar, intenta otra vez",
  },
  en: {
    title: "Lumi's business workshop",
    step1: "1. What would you like to learn to sell?",
    otherPh: "Type your idea (e.g. slime, dog treats...)",
    step2: "2. Superpower: name your business!",
    power: "Use my superpower",
    thinking: "Lumi is thinking...",
    again: "More names",
    pick: "Pick this one",
    saved: "Saved to My businesses!",
    tip: "Lumi's tip",
    mine: "My businesses",
    signIn: "Sign in to use Lumi's superpower",
    error: "Lumi couldn't think, try again",
  },
};
